import { Text, VStack } from '@rtkwlf/fenrir-react';

import { ExternalTextLink } from './external-text-link';

type InfoFieldProps = {
  name: string;
  value: string;
  url?: string;
};

export const InfoField: React.FC<InfoFieldProps> = ({ name, value, url }) => (
  <VStack gap="small" xAlign="left" data-testid={`info-${name}`}>
    <Text styledAs="body4">{name}</Text>
    {url ? (
      <ExternalTextLink href={url} text={value} />
    ) : (
      <Text wordBreak="break-all">{value}</Text>
    )}
  </VStack>
);
